import {
  WOrderPaymentStatus,
  WOrderHeader,
  WOrderStepper,
  WOrderVehicleInfo,
  WOrderPaymentSummary,
  WOrderQualitySurvey,
  WOrderStatus,
  WOrderTagGrid,
  WOrderNotesAndRequests,
  WOrderServices,
  GenSnackBar,
  WOrderErrorPage,
  WOConstraintsSnackBar,
  WOrderReconServices,
  isReconditioning,
} from '@pinnacleautomotive/clarity-components';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';
import { OrderTypes, StatusCode } from '../../common/enums/enums';
import DownloadPdf from '../../common/helpers/DownloadPdf';
import EditVehicleModal from '../../components/EditVehicleModal';
import { hasDealerShipManagerRole } from '../../helpers/users';
import {
  addServiceToWorkOrder,
  cloaseAddServiceModal,
  cancelStepChangeStatus,
  closeEditVechileModal,
  deleteServiceFromWorkOrder,
  editVehicleDetails,
  getWorkOrderData,
  openAddServiceModal,
  openEditVechileModal,
  getWorkOrderToPdf,
  setPromiseDate,
  addSurvey,
  resetSurveySentStatus,
  openModalQualitySurvey,
  closeModalQualitySurvey,
  hideCancelConfirmationSnackBar,
  addWorkOrderNote,
  clearCompletionEditStatus,
  clearAddServiceError,
} from '../../redux/actions/orderDetailsActions';
import { useGetVehiclePhotoCountMutation } from '../../redux/rtk/vendors.services';
import {
  selectWorkOrder,
  selectIsLoading,
  selectIsEditVehicleLoading,
  selectEditVehicleModalOpen,
  selectAddServiceModalOpen,
  selectDeleteServiceStatus,
  selectIsAddServiceLoading,
  selectIsDeleteServiceLoading,
  stepStatusChangeApiIsLoading,
  selectIsLoadingEditCompletion,
  selectIsLoadingAddSurvey,
  selectSurveySentStatus,
  selectAddSurveyModalOpen,
  selectShowCancelSuccesSnackBar,
  selectShowCancelErrorSnackBar,
  isAddNoteApiLoading,
  selectPromiseDateStatus,
  selectAddServiceError,
} from '../../redux/selectors/ordersDetailsSelectors';
import { selectCurrentUserRole } from '../../redux/selectors/userDataSelectors';
import AddServiceModal from './components/AddServiceModal';
import ApproveFooter from './components/ApproveFooter';
import DeleteServiceStatus from './components/DeleteServiceStatus';
import SurveyFooter from './components/SurveyFooter';
import SurveyModal from './components/SurveyModal';
import WOrderError500Page from './WOrderError500Page';

const OrderDetail = props => {
  const { t } = useTranslation(['orders', 'global']);
  const dispatch = useDispatch();
  const { vendorOrderId } = useParams();
  const history = useHistory();
  const isEditVehicleLoading = useSelector(selectIsEditVehicleLoading);
  const isDeleteServiceApiLoading = useSelector(selectIsDeleteServiceLoading);
  const addServiceModalStatus = useSelector(selectAddServiceModalOpen);
  const deleteServiceStatus = useSelector(selectDeleteServiceStatus);
  const isAddServiceLoading = useSelector(selectIsAddServiceLoading);
  const isLoadingEditCompletion = useSelector(selectIsLoadingEditCompletion);
  const promiseDateStatus = useSelector(selectPromiseDateStatus);
  const isLoadingAddSurvey = useSelector(selectIsLoadingAddSurvey);
  const surveySentStatus = useSelector(selectSurveySentStatus);
  const addSurveyModalOpen = useSelector(selectAddSurveyModalOpen);
  const data = useSelector(selectWorkOrder);
  const editVehicleModalOpen = useSelector(selectEditVehicleModalOpen);
  const userRoles = useSelector(selectCurrentUserRole);
  const changeStepIsLoading = useSelector(stepStatusChangeApiIsLoading);
  const showCancelSuccesSnackBar = useSelector(selectShowCancelSuccesSnackBar);
  const showCancelErrorSnackBar = useSelector(selectShowCancelErrorSnackBar);
  const isNoteLoading = useSelector(isAddNoteApiLoading);
  const addServiceError = useSelector(selectAddServiceError);
  const [photoCount, setPhotoCount] = useState(null);

  const [openGenSnack, setopenGenSnack] = useState(false);
  const [errorState, setErrorState] = useState(null);
  const [openDeleteStatus, setOpenDeleteStatus] = useState(false);
  const [putVehicle, { isLoading: isLoadingVehicle }] =
    useGetVehiclePhotoCountMutation();
  const isLoading = useSelector(selectIsLoading);
  const cancelEditVehicle = () => {
    dispatch(closeEditVechileModal());
  };

  const buildDataForModal = () => ({
    ...(data?.vehicle || {}),
    custody: {
      stockNumber: data?.stockNumber,
      custodyId: data?.custodyId,
    },
    po: data?.po,
    ro: data?.ro,
    orderId: data?.orderId,
    vehicleId: data?.vehicle.vehicleId,
  });

  const onSaveEditVehicle = vehicleData => {
    dispatch(
      editVehicleDetails({
        vendorOrderId,
        newData: vehicleData,
        oldData: buildDataForModal(),
      })
    );
  };

  const onDeleteService = ({ serviceId }) => {
    dispatch(deleteServiceFromWorkOrder({ vendorOrderId, serviceId })).then(
      () => setOpenDeleteStatus(true)
    );
  };

  const handlePhotoCount = async choosenOrder => {
    if (!choosenOrder?.vehicle.vin) return;
    const apiBody = {
      orderId: choosenOrder?.orderId,
      dealerId: choosenOrder?.dealer?.companyId,
    };
    try {
      const photoCountResponse = await putVehicle({
        vinOrStockNumber: choosenOrder?.vehicle?.vin,
        body: apiBody,
      }).unwrap();
      const photoCountValue = choosenOrder?.vehicle?.showPhotoCount
        ? photoCountResponse?.photosCount || 0
        : null;
      setPhotoCount(photoCountValue);
    } catch (err) {
      // eslint-disable-next-line no-console
      console.log('Error in fetching photo count', err);
      setPhotoCount(null);
    }
  };

  const addService = newService => {
    dispatch(
      addServiceToWorkOrder({
        vendorOrderId: data.vendorOrderId,
        serviceId: newService.servicePriceId,
      })
    );
  };

  useEffect(() => {
    dispatch(getWorkOrderData({ vendorOrderId })).then(result => {
      if (result.payload.status) {
        setErrorState(result.payload.status);
      }
    });
  }, [dispatch, vendorOrderId]);

  useEffect(() => {
    setPhotoCount(null);
    if (data?.vehicle?.showPhotoCount) {
      handlePhotoCount(data);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  const handleCancelStatus = ({ vendorOrderId: VoId, cancellingNote }) => {
    dispatch(cancelStepChangeStatus({ VoId, cancellingNote }));
  };

  const exportWorkOrder = () => {
    setopenGenSnack(true);
    dispatch(
      getWorkOrderToPdf({
        vendor_order_id: data.vendorOrderId,
      })
    ).then(({ payload: pdfString }) => {
      DownloadPdf(pdfString, data.woNumber);
    });
  };

  const showErrorState = error => {
    const { INTERNAL_SERVER_ERROR } = StatusCode;
    if (INTERNAL_SERVER_ERROR === error) {
      return <WOrderError500Page />;
    }
    return <WOrderErrorPage onClickError={() => history.push('/orders')} />;
  };

  const changeCompletionTime = change => {
    const promiseDate = change.returnToEstimated ? null : change.promiseDate;
    dispatch(
      setPromiseDate({ vendorOrderId: data.vendorOrderId, promiseDate })
    );
  };

  const submitSurvey = survey => {
    dispatch(addSurvey({ survey, vendorOrderId: data.vendorOrderId }));
  };

  const sendResetSurveySentStatus = () => {
    dispatch(resetSurveySentStatus());
  };

  const dispatchHideCancelConfirmation = () => {
    dispatch(hideCancelConfirmationSnackBar());
  };

  const sendResetPromiseDate = () => {
    dispatch(clearCompletionEditStatus());
  };

  const notesHandler = ({ note, vendorOrderId: VoId }) => {
    dispatch(addWorkOrderNote({ note, VoId }));
  };

  return isLoading || data ? (
    <>
      <WOConstraintsSnackBar
        error={addServiceError}
        onCleanErrors={() => dispatch(clearAddServiceError())}
      />
      <GenSnackBar
        title={t('cancelConfirmation')}
        open={showCancelSuccesSnackBar}
        onClose={() => dispatchHideCancelConfirmation()}
      />
      <GenSnackBar
        title={t('cancelError')}
        open={showCancelErrorSnackBar}
        type="error"
        onClose={() => dispatchHideCancelConfirmation()}
      />
      <GenSnackBar
        title={t('newOrder.alertExportPdf')}
        open={openGenSnack}
        icon={false}
        color={'#323232'}
        onClose={() => setopenGenSnack(false)}
      />
      <EditVehicleModal
        open={editVehicleModalOpen}
        title={t('newOrder.editVehicle')}
        onClose={cancelEditVehicle}
        vehicleDetails={buildDataForModal()}
        onSave={onSaveEditVehicle}
        loading={isEditVehicleLoading}
        showRo={data && !isReconditioning(data)}
        showPo={data && !isReconditioning(data)}
      />
      <SurveyModal
        data={data}
        open={addSurveyModalOpen}
        onClose={() => dispatch(closeModalQualitySurvey())}
        onSubmit={submitSurvey}
        isLoading={isLoadingAddSurvey}
      />
      <WOrderHeader
        data={data}
        isLoading={isLoading}
        onClickDownload={() => exportWorkOrder()}
      />
      <WOrderVehicleInfo
        data={data}
        isLoading={isLoading}
        apiLoading={isLoadingVehicle}
        photoCount={photoCount}
        onClickEdit={() => dispatch(openEditVechileModal())}
      />
      <WOrderTagGrid
        data={data}
        isLoading={isLoading}
        history={history}
        hasActionsEnabled={false}
        enableAddEstimate={false}
        isDealer={true}
      />
      <WOrderPaymentStatus data={data} isLoading={isLoading} />
      <WOrderPaymentSummary data={data} isLoading={isLoading} />
      <WOrderQualitySurvey data={data} />
      <WOrderStatus
        data={data}
        isLoading={isLoading}
        isLoadingEditCompletion={isLoadingEditCompletion}
        onChangeCompletionTime={changeCompletionTime}
      />
      <WOrderStepper
        isVendor={false}
        isManager={hasDealerShipManagerRole([userRoles.roleName])}
        data={data}
        isLoading={isLoading}
        isApiLoading={changeStepIsLoading}
        statusCancel={handleCancelStatus}
      />
      <WOrderNotesAndRequests
        data={data || {}}
        isLoading={isLoading}
        notesHandler={notesHandler}
        noteLoading={isNoteLoading}
      />
      {data?.orderType === OrderTypes.WORK_ORDER ||
      data?.orderType === OrderTypes.SERVICE_ORDER ? (
        <WOrderServices
          data={data}
          isLoading={isLoading}
          edit={true}
          deleteServicesFunction={onDeleteService}
          apiIsLoading={isDeleteServiceApiLoading}
          autoApprove={true}
          onAddServiceClick={() => dispatch(openAddServiceModal())}
          orderType={data?.orderType}
        />
      ) : (
        <WOrderReconServices
          data={data}
          isLoading={isLoading}
          isDealer={true}
        />
      )}
      <AddServiceModal
        loading={isAddServiceLoading}
        open={addServiceModalStatus}
        data={data}
        onClose={() => dispatch(cloaseAddServiceModal())}
        onAddService={addService}
      />
      <DeleteServiceStatus
        open={openDeleteStatus}
        deleteModalStatus={deleteServiceStatus}
        onClose={() => setOpenDeleteStatus(false)}
      />
      <SurveyFooter
        data={data}
        isLoading={isLoading}
        onOpenSubmitQuality={() => dispatch(openModalQualitySurvey())}
      />
      <ApproveFooter data={data} />
      <GenSnackBar
        open={surveySentStatus === 'success'}
        onClose={sendResetSurveySentStatus}
        title={t('survey.success')}
      />
      <GenSnackBar
        open={surveySentStatus === 'error'}
        type="error"
        onClose={sendResetSurveySentStatus}
        title={t('survey.error')}
      />
      <GenSnackBar
        open={promiseDateStatus === 'success'}
        onClose={sendResetPromiseDate}
        message={t('promiseDateSnacks.success')}
      />
      <GenSnackBar
        open={promiseDateStatus === 'error'}
        type="error"
        onClose={sendResetPromiseDate}
        message={t('promiseDateSnacks.error')}
      />
    </>
  ) : (
    showErrorState(errorState)
  );
};

export default OrderDetail;
